import { Icon, Typography } from "@bonprix/design-system";
import React from "react";

const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const HighlightedText = ({ text, highlight }) => {
    if (!highlight) return <span>{text}</span>;

    const escapedHighlight = escapeRegExp(highlight);
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));

    return (
        <>
            {parts.map((part, index) =>
                part.toLowerCase() === escapedHighlight.toLowerCase() ? (
                    <strong key={index}>{part}</strong>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </>
    );
};

export const SearchResultItem = ({ searchTerm, value,listMode, isActive, selectionMode, onSelect, id, onMouseOver }) => {
    let className = '';
    if (isActive) {
        if (selectionMode === 'HOVER') {
            className = 'hover';
        }
        if (selectionMode === 'SELECT') {
            className = 'active';
        }
    }

    return (
        <li
            id={id}
            role="option"
            aria-selected={isActive}
            className={`search__result-item ${className}`}
            onClick={(e) => {
                e.preventDefault();
                onSelect(value);
            }}
            onMouseDown={(e) => e.preventDefault()}
            onMouseEnter={onMouseOver}
        >
            <div className={'search__result-item-container'}>
                <Icon variant="search" />
                <div className="search__result_item-label">
                    <Typography variant="subtitle1" component="span">
                        {listMode === 'SUGGESTIONS' ? (
                            <HighlightedText text={value} highlight={searchTerm} />
                        ) : (
                            value
                        )}
                    </Typography>
                </div>
            </div>
        </li>
    );
};
